export default __webpack_public_path__ + "static/media/beatboy6.1482808a.gif";